import { css, css as _css } from '@emotion/react';
import IconX from '~icons/bx/x';
import IconChevronDown from '~icons/ci/chevron-down';
import { theme } from '@arc/frontend/ui-theme';
import { Input } from '../Inputs';
import { selectorStyles } from '../Selectors';
export function hubAutocompleteDefaultRenderInput({
  // UseAutocompleteProps
  disableClearable,
  // UseAutocompleteReturnValue
  setAnchorEl,
  getClearProps,
  getPopupIndicatorProps,
  popupOpen,
  focused,
  inputValue,
  // Other
  inputProps,
  testid,
  styles,
  // InputProps
  disabled,
  readOnly,
  endAdornment,
  ...moreInputProps
}) {
  const clearButton = <button {...getClearProps()} type="button" css={/*#__PURE__*/_css({
    color: theme.colors.text.tableHeader,
    marginLeft: '0.25rem',
    /**
     * Ultra-specific margin so the gap between the clear
     * button and the dropdown button matches the input
     * side padding
     */
    marginRight: '6px',
    cursor: 'pointer'
  }, process.env.NODE_ENV === "production" ? "" : ";label:clearButton;")}>
			<IconX width={20} height={20} />
		</button>;
  const popoverButton = <button {...getPopupIndicatorProps()} type="button" css={selectorStyles.adornmentIcon} data-testid={`${testid}-button`} disabled={disabled}>
			<IconChevronDown css={[disabled && /*#__PURE__*/css({
      color: theme.colors.text.disabled
    }, process.env.NODE_ENV === "production" ? "" : ";label:popoverButton;"), popupOpen && {
      rotate: '180deg'
    }, process.env.NODE_ENV === "production" ? "" : ";label:popoverButton;"]} width={20} height={20} />
		</button>;
  return <Input {...inputProps} {...moreInputProps} disabled={disabled} readOnly={readOnly} containerRef={setAnchorEl} data-testid={`${testid}-input`} autoComplete="new-password" endAdornment={<>
					{endAdornment}
					{disabled || readOnly ? null : <>
							{inputValue && !disableClearable && focused ? clearButton : null}
							{popoverButton}
						</>}
				</>} containerStyle={styles?.input} />;
}